import _ from 'lodash';
import Joi from 'joi';
import PropTypes from 'prop-types';

import Button from '../../themed/button';
import Conditional from '../../common/conditional';
import Form from '../../common/form';

import toastService from '../../../services/toastService';
import withAnomalySchema from '../../hoc/withAnomalySchema';

import { getFileUploadTypes } from '../../../utils/utilities';
import { getAnomalyTypeClassOptions } from '../../../utils/data';
import { CoverDataItem } from '../../../utils/models';
import { FVI_SCHEMA } from '../../../utils/constants';

class AnomalyItemWithCMD extends Form {
	state = {
		data: {
			location: '',
			cmd: '',
			description: [],
			recommendation: [],
			class: '',
			generalImage: [],
			closeImage: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		...FVI_SCHEMA,
		cmd: Joi.string().required().label('CDR'),
	};

	static propTypes = {
		options: PropTypes.array,
		onSave: PropTypes.func,
		anomalyItem: PropTypes.object,
		onCancel: PropTypes.func,
	};

	componentDidMount(): void {
		if (this.props.anomalyItem) {
			this.setState({ data: this.props.anomalyItem });
		}
	}

	componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{ data: any; errors: any; progress: number; loading: boolean; touched?: boolean; }>, snapshot?: any): void {
		if (this.props.anomalyItem && this.props.anomalyItem.id !== prevProps.anomalyItem?.id) {
			this.setState({ data: this.props.anomalyItem });
		}

		if (!_.isEqual(this.schema, this.props.schema)) {
			this.schema = { ...this.props.schema, cmd: Joi.string().required().label('CDR') };
		}
	}

	doSubmit = (): void => {
		this.props.onSave(this.state.data);

		this.setState({ 
			data: {
				location: '',
				cmd: '',
				description: [],
				recommendation: [],
				class: '',
				generalImage: [],
				closeImage: [],
			},
		});

		toastService.success('Anomaly Item Saved Successfully!');
	};

	mapAnomalyClasses = () => {
		return getAnomalyTypeClassOptions();
	};

	getSelectedClassDescription = () => {
		const classMatch = _.find(getAnomalyTypeClassOptions(), ['id', this.state.data.class]);
		if (classMatch) return classMatch.descriptions;

		return [];
	};
	
	getSelectedClassRecommendations = () => {
		const classMatch = _.find(getAnomalyTypeClassOptions(), ['id', this.state.data.class]);
		if (classMatch) return classMatch.recommendations;

		return [];
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						<Conditional isVisible={this.props.options.length === 0}>
							{this.renderInput({
								type: 'text',
								name: 'location',
								placeholder: 'Enter Anomaly Location',
								label: 'Anomaly Location',
							})}
						</Conditional>
						
						<Conditional isVisible={this.props.options.length > 0}>
							{this.renderSelect({
								options: this.props.options.map((option: CoverDataItem) => ({ id: option.value, name: option.label })),
								name: 'location',
								placeholder: 'Select Anomaly Location',
								label: 'Anomaly Location',
							})}
						</Conditional>
					</div>
					
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'cmd',
							placeholder: 'Enter CDR',
							label: 'CDR',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'class',
							placeholder: 'Select Anomaly Type',
							label: 'Anomaly Type',
							options: this.mapAnomalyClasses(),
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.getSelectedClassDescription(),
							name: 'description',
							placeholder: 'Enter Anomaly Description',
							label: 'Anomaly Description',
							isMulti: true,
						})}
					</div>

					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.getSelectedClassRecommendations(),
							name: 'recommendation',
							placeholder: 'Enter Remark & Recommendation',
							label: 'Remark & Recommendation',
							isMulti: true,
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderFileInput({
							max: this.props.max,
							multiple: this.props.max > 1,
							hideCaption: true,
							name: 'generalImage',
							accept: 'image/*,application/pdf',
							label: 'Anomaly Image (General View)',
							sublabel: 'Upload photos showing general view',
							types: getFileUploadTypes(),
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: this.props.max,
							multiple: this.props.max > 1,
							hideCaption: true,
							name: 'closeImage',
							accept: 'image/*,application/pdf',
							label: 'Anomaly Image (Close View)',
							sublabel: 'Upload photos showing close view',
							types: getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="divider mt-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Anomaly Item')}

					<Conditional isVisible={!!this.props.onCancel}>
						<div className="mx-4">
							<Button
								label="Cancel"
								style={{ backgroundColor: 'red' }}
								onClick={this.props.onCancel}
							/>
						</div>
					</Conditional>
				</div>
			</form>
		);
	}
}

export default withAnomalySchema(AnomalyItemWithCMD);
